var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2344 18.375C24.9844 19.6875 24.0469 21.3281 22.5 21.3281H2.48438C0.9375 21.3281 0 19.6875 0.75 18.375L10.7812 1.3125C11.5312 0 13.4531 0 14.25 1.3125L24.2344 18.375ZM11.3906 6.70312V12.7031C11.3906 13.3594 11.9531 13.8281 12.5156 13.8281C13.125 13.8281 13.6406 13.3594 13.6406 12.7031V6.70312C13.6406 6.09375 13.125 5.57812 12.5156 5.57812C11.8594 5.57812 11.3906 6.09375 11.3906 6.70312ZM12.5156 18.3281C13.3125 18.3281 13.9688 17.6719 13.9688 16.875C13.9688 16.0781 13.3125 15.4219 12.5156 15.4219C11.6719 15.4219 11.0156 16.0781 11.0156 16.875C11.0156 17.6719 11.6719 18.3281 12.5156 18.3281Z",
    fill: "#D50019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyIcon);
export default __webpack_public_path__ + "static/media/emergency-icon.2804d6532394866fde115eed606c2316.svg";
export { ForwardRef as ReactComponent };